import { useState, useEffect } from 'react';
import { settingsService } from '../services/settingsService';

/**
 * Hook som leser innstillingen 'packing.hideConfirmedPackages'.
 *
 * Styrer om bekreftede kolli skjules fra hovedlista i pakkebekreftelsen
 * (PackageConfirmationSection). Når på: hovedrutenettet viser kun gjenstående
 * kolli, og bekreftede flyttes til en sammenleggbar «Bekreftet»-seksjon. Da
 * står operatøren til slutt igjen med kun de få uskannede kolliene og kan lett
 * lete dem opp fysisk. Rent UI-filter — påvirker ikke ApprovedYesNo i databasen.
 *
 * Oppløsning følger hierarkiet Profile → System → Default via getEffectiveSetting.
 *
 * Default: false (av med mindre tenant/profil eksplisitt slår den på).
 */
export function usePackingHideConfirmedPackages(): boolean {
  const [enabled, setEnabled] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;

    const loadSetting = async () => {
      try {
        const setting = await settingsService.getEffectiveSetting('packing.hideConfirmedPackages');
        if (!cancelled) {
          if (setting && setting.currentValue !== null && setting.currentValue !== undefined) {
            const val = setting.currentValue.toString().toLowerCase();
            setEnabled(val === 'true' || val === '1' || val === 'ja');
          } else {
            setEnabled(false);
          }
        }
      } catch (err) {
        console.warn('Could not load packing.hideConfirmedPackages setting, defaulting to false:', err);
        if (!cancelled) {
          setEnabled(false);
        }
      }
    };

    loadSetting();

    return () => { cancelled = true; };
  }, []);

  return enabled;
}
